export function deferAction(action) {
  setTimeout(action, 1);
}
export var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};